import Vue from 'vue';

function Receipt(config) {
	if (!(this instanceof Receipt)) {
		return new Receipt(config);
	}
	if (config) {
		Vue.util.extend(this, config);
	}
}

Receipt.prototype = {
	constructor: Receipt,

	amount: 0,
	total: 0,
	count: 0,
	cardBrand: '',
	cardLast4: '',
	id: '',
	chargeId: '',
	invoice: '',
	isPaid: false,
	overdue: false,
	items: null,
	paymentAttempts: 0,
	createdDate: null,
	processedDate: null,

	toString: function () {
		return '[Receipt:' + (this.id || this.last4) + ']';
	},

	toJSON: function () {
		return toDTO(this);
	}
};

function getCardType(brand) {
	brand = (brand + '').toLowerCase();
	switch (brand) {
	case 'american express': return 'amex';
	case 'diners club': return 'diners';
	case 'null':
	case 'unknown': return '';
	default: return brand;
	}
}

function toDollars(cents) {
	return +(cents / 100).toPrecision(15);
}

function totalSum(sum, item) {
	if (item && isFinite(item.amount)) {
		sum += item.amount;
	}
	return sum;
}

function itemFromDto(dto) {
	return dto && {
		amount: toDollars(dto.amountCents),
		description: dto.description
	};
}

function today() {
	var date = new Date();
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setMilliseconds(0);
	return date;
}

function toCents(dollars) {
	return +(dollars * 100).toPrecision(15);
}

function itemToDto(item) {
	return item && {
		amountCents: toCents(item.amount),
		description: item.description
	};
}

function toDTO (receipt) {
	return receipt && {
		id: receipt.id,
		invoice: receipt.invoice,
		createdOn: receipt.createdDate,
		nextPaymentAttemptOn: receipt.processedDate,
		amountDueCents: receipt.amount * 100 | 0,
		cardBrand: receipt.cardBrand,
		cardLast4: receipt.cardLast4,
		isPaid: receipt.isPaid,
		items: receipt.items && receipt.items.map(itemToDto)
	};
}

function fromDTO (dto) {
	if (!dto) {
  	  return null;
	}
	var created =  dto.createdOn ? new Date(dto.createdOn) : null,
		processed = dto.nextPaymentAttemptOn ? new Date(dto.nextPaymentAttemptOn) : created,


		subtotal = toDollars(dto.subtotalCents),
		discountedTotal = toDollars(dto.totalCents),
		tax = dto.tax ? toDollars(dto.tax) : null,

		cardCharge = toDollars(dto.amountDueCents),
		couponAdjustment = subtotal - discountedTotal,
		creditAdjustment = discountedTotal - cardCharge,
		creditApplied = Math.max(0, creditAdjustment),
		creditAdded = Math.min(0, creditAdjustment);

	return new Receipt({
		id: dto.id,
		chargeId: dto.chargeId,
		invoice: dto.invoice,
		createdDate: created,
		processedDate: processed,
		amount: cardCharge,
		coupon: dto.coupon ? {
			code: dto.coupon,
			discount: couponAdjustment
		} : null,
		creditTendered: creditApplied,
		creditAdded: creditAdded,
		total: discountedTotal,
		subtotal: subtotal,
		cardBrand: getCardType(dto.cardBrand),
		cardLast4: dto.cardLast4,
		tax: tax,
		isPaid: dto.isPaid === true,
		paymentAttempts: dto.paymentAttemptCount || 0,
		overdue: (dto.amount > 0) && dto.isPaid === false && (processed <= today()),
		paymentFailed: cardCharge > 0 && dto.isPaid === false && dto.paymentAttemptCount > 0,
		items: dto.items && dto.items.map(itemFromDto) || []
	});
}

export default {
	toDTO,
	fromDTO
};



// WEBPACK FOOTER //
// ./src/store/models/receipt.js